import * as React from "react";

const DirectionIcon = (props) => (
  <svg
    viewBox="0 0 25 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      d="m.472 13.855 10.87 10.898a1.213 1.213 0 0 0 1.713.002l10.922-10.897a1.211 1.211 0 0 0 0-1.715L13.055 1.247a1.21 1.21 0 0 0-1.712.002L.473 12.146a1.21 1.21 0 0 0 0 1.71Zm8.121-3.276h6.054V8.158l3.632 3.632-3.632 3.632v-2.421h-3.632v4.843H8.593v-7.265Z"
      fill="currentColor"
    />
  </svg>
);

export default DirectionIcon;
